import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUp2 from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadEquipe() {
    const [lista, setlista] = useState([]);
    const [listasupervisor, setlistasupervisor] = useState([]);
    const [listacolaborador, setlistacolaborador] = useState([]);
    const [listaequipefuncionario, setlistaequipefuncionario] = useState([]);

    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [edtcodequipe, setedtcodequipe] = useState(0);
    const [edtdescricao, setedtdescricao] = useState("");
    const [edtcodsupervisor, setedtcodsupervisor] = useState(0);

    const [codequipefuncionario, setcodequipefuncionario] = useState(0);
    const [codfuncionario, setcodfuncionario] = useState(0);

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenFunc, setIsOpenFunc] = useState(false);

    const { codassinante, selectedCompany, accessKey } = useAppContext(); 

    const handleOpen = (cad) => {
        setedtcodequipe(cad.codequipe);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        Excluir();
        setIsOpen(false);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOpenFunc = (cad) => {
        setcodequipefuncionario(cad.codequipefuncionario);
        setIsOpenFunc(true);
    };

    const handleConfirmaFunc = () => {
        ExcluirCadItem();
        setIsOpenFunc(false);
    };

    const handleCloseFunc = () => {
        setIsOpenFunc(false);
    };

    function ListarEquipeFuncionario() {
        api
            .get("/v1/cadastro/equipe/equipefuncionario", {
                params: {
                    codequipe: edtcodequipe,
                    busca: ""
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistaequipefuncionario(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarSupervisor() {
        api
            .get("v1/cadastro/supervisor", {
                params: {
                    busca: "",
                    codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistasupervisor(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarColaborador() {
        api
            .get("v1/cadastro/colaborador", {
                params: {
                    busca: "",
                    codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistacolaborador(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarEquipe() {
        api
            .get("v1/cadastro/equipe", {
                params: {
                    busca: abusca,
                    codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(() => {
        ListarEquipe();
    }, [abusca, showform]);

    function Cadastrar() {
        api
            .post(
                "v1/cadastro/equipe",
                {
                    descricao: edtdescricao,
                    codsupervisor: edtcodsupervisor,
                    excluido: "N",
                    codempresa: selectedCompany,
                    codassinante,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarEquipe();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Editar() {
        api
            .put(
                "v1/cadastro/equipe",
                {
                    codequipe: edtcodequipe,
                    codsupervisor: edtcodsupervisor,
                    descricao: edtdescricao,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarEquipe();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("v1/cadastro/equipe", {
                params: {
                    codequipe: edtcodequipe,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarEquipe();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setedtcodequipe(0);
        setedtcodsupervisor(0);
        setedtdescricao("");

        setcodfuncionario(0);

        ListarColaborador();
        ListarSupervisor();
    }

    function openModalEditar(props) {
        setshowform(true);
        setnovo(false);

        setedtcodequipe(props.codequipe);
        setedtcodsupervisor(props.codsupervisor);

        setedtdescricao(props.descricao);

        setcodfuncionario(0);

        ListarColaborador();
        ListarSupervisor();
    }

    function AddFuncionario() {
        if (edtcodequipe === 0) {
            if (edtcodsupervisor === 0) {
                alert("Informe o Gestor");
            } else {
                CadastrarNovo();
            }
        } else if (codfuncionario === 0) {
            alert("Informe o profissional");
        } else {
            CadastrarEquipeFunc();
        }
    }

    function CadastrarNovo() {
        api
            .post(
                "v1/cadastro/equipe",
                {
                    descricao: edtdescricao,
                    codsupervisor: edtcodsupervisor,
                    codassinante,
                    excluido: "N",
                    codempresa: selectedCompany,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then((response) => {
                setedtcodequipe(response.data.codequipe);
                setnovo(false);

                api
                    .post(
                        "v1/cadastro/equipe/equipefuncionario",
                        {
                            codequipe: edtcodequipe,
                            codfuncionario,
                            codempresa: selectedCompany,
                            codassinante,
                            excluido: "N",
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },
                        }
                    )
                    .then(() => {
                        ListarEquipeFuncionario();
                    })
                    .catch(function (err) {
                        console.log("ops! ocorreu um erro: " + err);
                    });
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function CadastrarEquipeFunc() {
        api
            .post(
                "v1/cadastro/equipe/equipefuncionario",
                {
                    codequipe: edtcodequipe,
                    codfuncionario,
                    codempresa: selectedCompany,
                    codassinante,
                    excluido: "N",
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarEquipeFuncionario();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirCadItem() {
        api
            .delete("/v1/cadastro/equipe/equipefuncionario", {
                params: {
                    codequipefuncionario,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarEquipeFuncionario();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div>
                        <div>
                            <PopUp isOpen={isOpen} onClose={handleClose}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja excluir esse registro?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirma}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleClose}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp>

                            <PopUp2 isOpen={isOpenFunc} onClose={handleCloseFunc}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja excluir esse Profissional?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirmaFunc}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleCloseFunc}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp2>
                        </div>

                        <Modal
                            isOpen={showform}
                            onRequestClose={closeModal}
                            overlayClassName="modal-overlay"
                            className="modal-content"
                        >
                            <div className="container-fluid h-100">
                                <div className="row">
                                    {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                </div>
                                <div className="row">
                                    <hr />
                                </div>

                                <div className="row">
                                    <form>
                                        <div className="row col-sm-12">
                                            <div className="col-sm-9">
                                                <label htmlFor="descricao" className="form-label">
                                                    Descrição
                                                </label>
                                                <input
                                                    type="text"
                                                    id="descricao"
                                                    className="form-control"
                                                    placeholder="Descrição"
                                                    value={edtdescricao}
                                                    onChange={(e) => setedtdescricao(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="row col-sm-12">
                                            <div className="col-sm-9">
                                                <label htmlFor="supervisor" className="form-label">
                                                    Gestor
                                                </label>
                                                <select
                                                    id="supervisor"
                                                    className="form-select"
                                                    value={edtcodsupervisor}
                                                    onChange={(e) => setedtcodsupervisor(e.target.value)}
                                                >
                                                    <option value="0">Escolha o supervisor</option>
                                                    {listasupervisor.map(function (funcionario) {
                                                        return (
                                                            <option
                                                                key={funcionario.codcolaborador}
                                                                value={funcionario.codcolaborador}
                                                            >
                                                                {funcionario.nome}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5">
                                                <label htmlFor="funcionario" className="form-label">
                                                    Profissional da Equipe
                                                </label>
                                                <select
                                                    id="funcionario"
                                                    className="form-select"
                                                    value={codfuncionario}
                                                    onChange={(e) => setcodfuncionario(e.target.value)}
                                                >
                                                    <option value="0">Escolha o profissional</option>
                                                    {listacolaborador.map(function (func) {
                                                        return (
                                                            <option
                                                                key={func.codcolaborador}
                                                                value={func.codcolaborador}
                                                            >
                                                                {func.nome}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>

                                            <div className="col-sm-1 d-flex justify-content-center mt-2">
                                                <button
                                                    type="button"
                                                    id="btnadd"
                                                    className="btn btn-success"
                                                    onClick={AddFuncionario}
                                                >
                                                    Adicionar
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="row col-sm-12">
                                                <div className="row">
                                                    <table className="table table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Código</th>
                                                                <th>Cód. Profissional</th>
                                                                <th>Profissional</th>
                                                                <th className="acao">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {listaequipefuncionario.map(function (item) {
                                                                return (
                                                                    <tr key={item.codequipefuncionario}>
                                                                        <th>{item.codequipefuncionario}</th>
                                                                        <th>{item.codfuncionario}</th>
                                                                        <th>{item.nome}</th>
                                                                        <th>
                                                                            <div className="d-flex justify-content-center">
                                                                                <button
                                                                                    type="button"
                                                                                    id="btnexcluiritem"
                                                                                    className="btn fa-solid fa-trash"
                                                                                    onClick={() => handleOpenFunc(item)}
                                                                                ></button>
                                                                            </div>
                                                                        </th>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <th colSpan={4}>
                                                                    Quantidade de Registros:{" "}
                                                                    {listaequipefuncionario.length}
                                                                </th>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button className="btn btn-danger ms-4" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button className="btn btn-success ms-4" onClick={Salvar}>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="row">
                        <h1 className="ms-4">Cadastro de Equipe</h1>
                        <p className="ms-4">
                            Rotina para cadastrar todas as equipes da empresa.
                        </p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-10">
                            <label className="d-block" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Descrição ou gestor"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>
                        <div className="col-2 d-flex justify-content-center">
                            <button
                                className="btn btn-success btnnovo"
                                onClick={() => openModalNovo()}
                            >
                                Novo
                            </button>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Gestor</th>
                                    <th className="acao">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item) {
                                    return (
                                        <tr key={item.codequipe}>
                                            <th>{item.codequipe}</th>
                                            <th>{item.descricao}</th>
                                            <th>{item.nome}</th>
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        className="btn fa-regular fa-pen-to-square"
                                                        onClick={() => openModalEditar(item)}
                                                    ></button>
                                                    <button
                                                        className="btn fa-solid fa-trash"
                                                        onClick={() => handleOpen(item)}
                                                    ></button>
                                                </div>
                                            </th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={4}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CadEquipe;
